import { api } from "../../api/axios";
const controller = "Price";

export async function GetPricesByBrandIdAsync(id) 
{
  return await api.get(`${controller}/GetPricesByBrandId/${id}`);
}
